(() => {
  document.querySelectorAll('form[id$="Languages"]').forEach(form => {
    form.addEventListener('submit', event => {
      const target = new URL(window.location.href);
      const view = target.searchParams.get('view');
      if (!view || !view.startsWith('jdo-pl')) return;
      if (view === 'jdo-pl') target.searchParams.delete('view');
      else target.searchParams.set('view', view.replace('jdo-pl-', 'jdo-'));
      const field = form.querySelector('input[name="return_to"]');
      if (field) field.value = target.pathname + target.search;
      if (event.submitter && event.submitter.value === document.documentElement.dataset.nativeLocale) {
        event.preventDefault();
        event.stopImmediatePropagation();
        window.location.assign(target.href);
      }
    }, true);
  });
})();
